// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".farewell-text[data-v-1766b2ff]{margin-bottom:30px}.farewell-text[data-v-1766b2ff],.text-field[data-v-1766b2ff]{color:#606266;font-weight:500;font-size:16px}.text-field[data-v-1766b2ff]{margin-top:10px;margin-bottom:10px}.text-capitalize[data-v-1766b2ff]{text-transform:capitalize}.star-center[data-v-1766b2ff]{text-align:center}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
